/**
 * Enhanced Upsell Builder (Page Builder)
 * Wraps the modular BuilderPage component with templates, undo/redo, and 10 block types.
 * See UpsellBuilder.legacy.tsx for the original monolithic implementation.
 */
import { BuilderPage } from '../components/builder'

export default function UpsellBuilder() {
  return <BuilderPage />
}
